import videojs, { VideoJSPlayer } from 'video.js';

export const createCustomButton = (
  name: string,
  classNames: Array<string>,
  eventName: string,
  ariaLabel: string,
) => {
  const Button = (videojs as VideoJSPlayer).getComponent('Button');
  const MyButton = (videojs as VideoJSPlayer).extend(Button, {
    constructor: function (...args) {
      Button.apply(this, args);
      classNames.map(this.addClass.bind(this));
      this.setAttribute('aria-label', ariaLabel);
    },
    handleClick: function () {
      this.player_.trigger(eventName);
    },
  });
  (videojs as VideoJSPlayer).registerComponent(name, MyButton);
};

const SourceTypes = Object.freeze({
  MP4: 'video/mp4',
  HLS: 'application/x-mpegURL',
});

type SourceType = (typeof SourceTypes)[keyof typeof SourceTypes];

type SourceDescription = {
  type: SourceType;
  srcRegex: RegExp;
};

type SourceDescriptions = Array<SourceDescription>;

const sourceDescriptionList: SourceDescriptions = [
  {
    type: SourceTypes.MP4,
    srcRegex: /\.mp4$/,
  },
  {
    type: SourceTypes.HLS,
    srcRegex: /\.m3u8$/,
  },
];

export const getTypeFromSrcUrl = (
  src: string,
  defaultType: SourceType = SourceTypes.MP4,
  sourceDescriptions: SourceDescriptions = sourceDescriptionList,
): SourceType => {
  for (let i = 0; i < sourceDescriptions.length; i++) {
    const srcDescription = sourceDescriptions[i];
    if (srcDescription?.srcRegex.test(src)) {
      return srcDescription?.type;
    }
  }

  return defaultType;
};
